module.exports = "<table class=\"table table-hover no-margin teams-table\"> <tbody> <tr ui-sref=\"crm.accounts.item.team({locationId: $ctrl.locationId, teamId: item.id})\" ng-repeat=\"item in $ctrl.teams track by item.id\"> <td>{{item.name}} <span class=pull-right>{{item.teamContacts.length}}</span></td> </tr> </tbody> </table> <div class=add-team-btn-cta> <i class=\"fa fa-plus link\" ui-sref=\"crm.accounts.item.team({locationId: $ctrl.locationId})\"></i> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/crm/teams/teams.list.html
// module id = 421
// module chunks = 0